import { render, staticRenderFns } from "./ResourceDetails.vue?vue&type=template&id=1b68c78f&scoped=true&"
import script from "./ResourceDetails.vue?vue&type=script&lang=ts&"
export * from "./ResourceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceDetails.vue?vue&type=style&index=0&id=1b68c78f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b68c78f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b68c78f')) {
      api.createRecord('1b68c78f', component.options)
    } else {
      api.reload('1b68c78f', component.options)
    }
    module.hot.accept("./ResourceDetails.vue?vue&type=template&id=1b68c78f&scoped=true&", function () {
      api.rerender('1b68c78f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ResourceDetails.vue"
export default component.exports